import { render, staticRenderFns } from "./UploadImage2.vue?vue&type=template&id=696cdbca&scoped=true"
import script from "./UploadImage2.vue?vue&type=script&lang=js"
export * from "./UploadImage2.vue?vue&type=script&lang=js"
import style0 from "./UploadImage2.vue?vue&type=style&index=0&id=696cdbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696cdbca",
  null
  
)

export default component.exports